/* Beauty by Adefunkeee, the install routine theme: step tabs, pickers, gallery, accordions, add to bag. */
(function () {
  'use strict';
  var T = window.theme || { strings: {} };

  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = (cents / 100);
    function withDelims(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelims(value, 2, ',', '.');
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }
  function moneyNoTrailing(cents) {
    var s = formatMoney(cents, T.moneyFormat);
    return s.replace(/([.,])00(?!\d)/, '');
  }
  function bound(el, key) {
    var k = 'bound' + key;
    if (el.dataset[k]) return true;
    el.dataset[k] = '1';
    return false;
  }

  /* ---------- Messages ---------- */
  function announce(msg) {
    var el = document.querySelector('[data-cart-status]');
    if (el) { el.textContent = ''; setTimeout(function () { el.textContent = msg; }, 50); }
  }
  // Errors are shown on screen as well as announced, so sighted shoppers see them too.
  var toastTimer = null;
  function notice(msg) {
    msg = msg || T.strings.error;
    announce(msg);
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 5000);
  }
  // Read Shopify's error text (for example "already sold out") from a failed cart request.
  function cartError(r) {
    return r.json().then(function (j) { throw new Error((j && (j.description || j.message)) || ''); }, function () { throw new Error(''); });
  }

  /* ---------- Bag ---------- */
  var bagQty = {};
  function rememberCart(cart) {
    bagQty = {};
    (cart.items || []).forEach(function (it) { bagQty[it.variant_id] = (bagQty[it.variant_id] || 0) + it.quantity; });
    setBagCount(cart.item_count);
    updateBagBar(cart);
    document.querySelectorAll('[data-bag-control]').forEach(syncStepper);
    return cart;
  }
  // Lets a page react when the bag changes (the cart page re-renders its totals).
  function bagChanged(cart) {
    document.dispatchEvent(new CustomEvent('bag:changed', { detail: cart }));
  }
  function fetchCart() {
    return fetch(T.cartUrl, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(rememberCart);
  }
  function addedMessage(cart) {
    return (cart.item_count === 1 ? T.strings.added_one : T.strings.added_other || '').replace('{count}', cart.item_count);
  }
  // Show Add to Bag, or the stepper with this variant's quantity once it is in the bag.
  function syncStepper(ctrl) {
    var btn = ctrl.querySelector('[data-add-current]');
    var stepper = ctrl.querySelector('[data-bag-stepper]');
    if (!btn || !stepper) return;
    var id = Number(btn.getAttribute('data-variant-id'));
    var q = bagQty[id] || 0;
    var hadFocus = stepper.contains(document.activeElement);
    btn.hidden = q > 0;
    stepper.hidden = q === 0;
    if (q > 0) {
      stepper.querySelector('[data-bag-qty]').textContent = stepper.hasAttribute('data-compact') ? String(q) : (T.strings.inBag || '{count}').replace('{count}', q);
      var minus = stepper.querySelector('[data-bag-step="-1"]');
      minus.setAttribute('aria-label', q === 1 ? minus.getAttribute('data-label-remove') : minus.getAttribute('data-label-fewer'));
      minus.querySelector('[data-icon-minus]').hidden = q === 1;
      minus.querySelector('[data-icon-bin]').hidden = q !== 1;
    } else if (hadFocus) {
      btn.focus();
    }
  }
  function changeQty(ctrl, delta, pressed) {
    if (!ctrl || ctrl.getAttribute('aria-busy') === 'true') return;
    var stepper = ctrl.querySelector('[data-bag-stepper]');
    var id = Number(ctrl.querySelector('[data-add-current]').getAttribute('data-variant-id'));
    var next = Math.max(0, (bagQty[id] || 0) + delta);
    // Busy is shown with aria-disabled rather than disabled, so the pressed button keeps keyboard focus.
    ctrl.setAttribute('aria-busy', 'true');
    stepper.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-disabled', 'true'); });
    return fetch(T.cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: next })
    }).then(function (r) {
      if (!r.ok) return cartError(r);
      return r.json();
    }).then(function (cart) {
      rememberCart(cart);
      bagChanged(cart);
      announce(next === 0 ? T.strings.removed : addedMessage(cart));
      if (next === 0) { var btn = ctrl.querySelector('[data-add-current]'); if (btn) btn.focus(); }
      else if (pressed && !stepper.hidden) pressed.focus();
    }).catch(function (err) {
      // Usually not enough stock for one more; show why, and the real quantity again.
      notice(err && err.message);
      return fetchCart();
    }).finally(function () {
      ctrl.removeAttribute('aria-busy');
      stepper.querySelectorAll('button').forEach(function (b) { b.removeAttribute('aria-disabled'); });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bag-step]');
    if (!b) return;
    e.preventDefault();
    changeQty(b.closest('[data-bag-control]'), Number(b.getAttribute('data-bag-step')), b);
  });
  function setBagCount(n) {
    document.querySelectorAll('[data-bag-link]').forEach(function (a) {
      var text = a.querySelector('[data-bag-text]');
      if (text) text.textContent = text.textContent.replace(/\(\d+\)/, '(' + n + ')');
      var badge = a.querySelector('[data-bag-count]');
      if (badge) { badge.textContent = n; badge.hidden = n === 0; }
      var label = a.getAttribute('aria-label');
      if (label) a.setAttribute('aria-label', label.replace(/\d+/, n).replace(/items?/, n === 1 ? 'item' : 'items'));
      a.classList.toggle('is-filled', n > 0);
    });
  }
  // The bag bar: count and subtotal, shown once the bag has something in it.
  function updateBagBar(cart) {
    var bar = document.querySelector('[data-bag-bar]');
    if (!bar) return;
    var n = cart.item_count || 0;
    var wasHidden = bar.hidden;
    bar.querySelector('[data-bag-bar-count]').textContent = (n === 1 ? bar.getAttribute('data-one') : bar.getAttribute('data-other')).replace('%count%', n);
    bar.querySelector('[data-bag-bar-total]').textContent = formatMoney(cart.total_price, T.moneyFormat);
    bar.hidden = n === 0;
    document.body.classList.toggle('has-bag-bar', n > 0);
    document.documentElement.classList.toggle('has-bag-bar', n > 0);
    if (wasHidden && n > 0) {
      bar.classList.remove('is-entering');
      void bar.offsetWidth;
      bar.classList.add('is-entering');
    }
  }
  function addToBag(id, qty, button) {
    if (!id) return Promise.resolve();
    // Ignore a second tap while the first is still on its way.
    if (button && button.getAttribute('aria-busy') === 'true') return Promise.resolve();
    if (button) button.setAttribute('aria-busy', 'true');
    return fetch(T.cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return cartError(r);
      return fetch(T.cartUrl, { headers: { 'Accept': 'application/json' } });
    }).then(function (r) { return r.json(); }).then(function (cart) {
      rememberCart(cart);
      bagChanged(cart);
      announce(addedMessage(cart));
      var ctrl = button && button.closest('[data-bag-control]');
      var plus = ctrl && ctrl.querySelector('[data-bag-stepper]:not([hidden]) [data-bag-step="1"]');
      if (plus) plus.focus();
    }).catch(function (err) {
      notice(err && err.message);
    }).finally(function () {
      if (button) button.removeAttribute('aria-busy');
    });
  }
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-add-current]');
    if (!c) return;
    // The product form's own submit handler deals with its main button.
    if (c.type === 'submit' && c.closest('[data-product-form]')) return;
    e.preventDefault();
    addToBag(c.getAttribute('data-variant-id'), 1, c);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[data-variant-input]').value;
    var qty = Number(form.querySelector('[data-qty-input]').value) || 1;
    addToBag(id, qty, form.querySelector('[data-add-current]'));
  });
  // Coming back with the Back button can show a cached page; read the bag again so quantities are true.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && document.querySelector('[data-bag-control], [data-bag-bar], [data-bag-link]')) fetchCart().catch(function () {});
  });

  /* ---------- Accordions ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.accordion__toggle');
    if (!b) return;
    var open = b.getAttribute('aria-expanded') === 'true';
    // One open at a time, as in the design.
    var group = b.closest('.accordions');
    if (group && !open) {
      group.querySelectorAll('.accordion__toggle[aria-expanded="true"]').forEach(function (o) {
        o.setAttribute('aria-expanded', 'false');
        var ob = document.getElementById(o.getAttribute('aria-controls'));
        if (ob) ob.hidden = true;
      });
    }
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    var body = document.getElementById(b.getAttribute('aria-controls'));
    if (body) body.hidden = open;
  });

  /* ---------- Pickers (homepage step panels and the product page) ---------- */
  function Picker(root) {
    this.root = root;
    // The scope holds the variant data and the pictures; the root holds this product's own price and buttons.
    this.scope = root.closest('[data-step-panel]') || root.closest('[data-product-page]') || root;
    var data = this.scope.querySelector('[data-variants]');
    this.variants = data ? JSON.parse(data.textContent) : [];
    this.groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));
    this.isPage = !!root.closest('[data-product-page]');
    var self = this;
    this.groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('.opt');
        if (!b) return;
        g.querySelectorAll('.opt').forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        self.update(Number(g.getAttribute('data-option-index')));
      });
    });
    this.current = this.find(this.selected()) || this.variants[0];
    this.markAvailability();
  }
  Picker.prototype.selected = function () {
    return this.groups.map(function (g) {
      var on = g.querySelector('.opt[aria-pressed="true"]');
      return on ? on.getAttribute('data-value') : null;
    });
  };
  Picker.prototype.find = function (opts) {
    return this.variants.find(function (v) {
      return opts.every(function (o, i) { return o === null || v.options[i] === o; });
    });
  };
  Picker.prototype.update = function (changed) {
    var opts = this.selected();
    var v = this.find(opts);
    if (!v) {
      // The combination does not exist; keep the option just picked and take the first match for it.
      v = this.variants.find(function (x) { return x.options[changed] === opts[changed] && x.available; }) ||
          this.variants.find(function (x) { return x.options[changed] === opts[changed]; });
      this.groups.forEach(function (g, i) {
        g.querySelectorAll('.opt').forEach(function (o) { o.setAttribute('aria-pressed', o.getAttribute('data-value') === v.options[i] ? 'true' : 'false'); });
      });
    }
    this.current = v;
    this.render();
    this.markAvailability();
  };
  Picker.prototype.markAvailability = function () {
    var opts = this.selected();
    var variants = this.variants;
    this.groups.forEach(function (g, gi) {
      g.querySelectorAll('.opt').forEach(function (o) {
        var val = o.getAttribute('data-value');
        var ok = variants.some(function (v) {
          return v.available && v.options[gi] === val && opts.every(function (x, i) { return i === gi || x === null || v.options[i] === x; });
        });
        o.classList.toggle('is-unavailable', !ok);
        // Say "sold out" in words too, not only with the strikethrough.
        var note = o.querySelector('[data-unavailable-note]');
        if (!ok && !note) {
          note = document.createElement('span');
          note.className = 'visually-hidden';
          note.setAttribute('data-unavailable-note', '');
          note.textContent = ', ' + (T.strings.unavailable || 'sold out');
          o.appendChild(note);
        } else if (ok && note) {
          note.remove();
        }
      });
    });
  };
  Picker.prototype.render = function () {
    var v = this.current, s = this.scope, root = this.root;
    if (!v) return;
    var now = root.querySelector('[data-price-now]');
    var was = root.querySelector('[data-price-was]');
    if (now) now.textContent = formatMoney(v.price, T.moneyFormat);
    if (was) {
      var sale = v.compare > v.price;
      was.hidden = !sale;
      was.textContent = sale ? formatMoney(v.compare, T.moneyFormat) : '';
    }
    var saving = root.querySelector('[data-saving]');
    if (saving) {
      var on = v.compare > v.price;
      saving.hidden = !on;
      if (on) saving.textContent = saving.textContent.replace(/^.*?(\s\S+)$/, moneyNoTrailing(v.compare - v.price) + '$1');
    }
    // Only this product's own buttons follow the picker; the step panel's other rows keep their own variants.
    var actions = root.querySelector('[data-product-form]') || root;
    actions.querySelectorAll(':scope > [data-add-current]').forEach(function (b) {
      b.setAttribute('data-variant-id', v.id);
      b.disabled = !v.available;
      b.textContent = v.available ? T.strings.addToBag : T.strings.soldOut;
    });
    var input = actions.querySelector('[data-variant-input]');
    if (input) input.value = v.id;
    // The Shop Pay Installments line re-renders itself when its form's variant input changes.
    root.querySelectorAll('.buy__installments [data-variant-input]').forEach(function (i) {
      i.value = v.id;
      i.dispatchEvent(new Event('change', { bubbles: true }));
    });
    var inst = root.querySelector('.buy__installments');
    if (inst) inst.hidden = !v.available;
    if (actions.hasAttribute('data-bag-control')) syncStepper(actions);
    var link = root.querySelector('[data-product-link]');
    if (link) link.href = root.getAttribute('data-product-url') + '?variant=' + v.id;
    var delivery = root.querySelector('[data-delivery-row]');
    if (delivery) delivery.hidden = !v.available;
    s.querySelectorAll('[data-variant-media]').forEach(function (m) {
      var mine = m.getAttribute('data-variant-media') === String(v.id);
      if (m.hasAttribute('data-view')) return; // gallery views are handled below
      m.hidden = !mine;
    });
    if (this.isPage) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
      var g = s.gallery;
      if (g) g.showVariant(v);
    }
  };

  /* ---------- Product gallery ---------- */
  function Gallery(scope, picker) {
    this.scope = scope;
    this.picker = picker;
    this.mode = scope.querySelector('[data-gallery-mode]') ? scope.querySelector('[data-gallery-mode]').getAttribute('data-gallery-mode') : scope.getAttribute('data-gallery-mode');
    this.view = 'boxed';
    var self = this;
    var sizes = scope.querySelector('.gallery__sizes');
    if (sizes) {
      var spans = Array.prototype.slice.call(sizes.children);
      spans.sort(function (a, b) { return parseFloat(a.getAttribute('data-size-sort')) - parseFloat(b.getAttribute('data-size-sort')); });
      spans.forEach(function (sp) { sizes.appendChild(sp); });
      var labels = spans.map(function (sp) { var l = sp.querySelector('.eyebrow'); return l ? l.textContent : ''; });
      sizes.setAttribute('aria-label', labels.join(', '));
      var thumb = scope.querySelector('[data-sizes-thumb]');
      if (thumb && !thumb.children.length) {
        spans.forEach(function (sp) {
          var img = sp.querySelector('img');
          if (!img) return;
          var cell = document.createElement('span');
          var copy = document.createElement('img');
          copy.src = img.currentSrc || img.src; copy.alt = '';
          cell.appendChild(copy); thumb.appendChild(cell);
        });
      }
    }
    scope.querySelectorAll('[data-thumb-view]').forEach(function (b) {
      b.addEventListener('click', function () { self.setView(b.getAttribute('data-thumb-view')); });
    });
    // The tutorial card fills the columns left after the last thumbnail, or takes its own row if fewer than ~260px remain.
    this.under = scope.querySelector('.gallery__under');
    this.card = this.under && this.under.querySelector(':scope > .watch-card');
    if (this.card) {
      if (window.ResizeObserver) new ResizeObserver(function () { self.placeCard(); }).observe(this.under);
      else window.addEventListener('resize', function () { self.placeCard(); });
      requestAnimationFrame(function () { self.placeCard(); });
      window.addEventListener('load', function () { self.placeCard(); });
    }
    scope.querySelectorAll('[data-thumb-media]').forEach(function (b) {
      b.addEventListener('click', function () { self.showMedia(b.getAttribute('data-thumb-media')); });
    });
  }
  Gallery.prototype.placeCard = function () {
    var under = this.under, card = this.card;
    if (!under || !card || getComputedStyle(card).display === 'none') return;
    under.style.gridTemplateColumns = '';
    under.classList.remove('is-one-row');
    var cols = getComputedStyle(under).gridTemplateColumns.split(' ').filter(function (c) { return /px$/.test(c); });
    var n = under.querySelectorAll('.thumb').length;
    var count = cols.length;
    if (!count) return;
    var colW = parseFloat(cols[0]) || 88;
    var gap = parseFloat(getComputedStyle(under).columnGap) || 12;
    var free = n % count === 0 ? 0 : count - (n % count);
    var needed = Math.ceil((260 + gap) / (colW + gap));
    if (free >= needed) { card.style.gridColumn = 'span ' + free; return; }
    // The card would drop to a row of its own and leave a gap after the thumbnails. If the thumbnails fit on
    // one row, shrink them a little so the card fits beside them instead.
    var styles = getComputedStyle(under);
    var width = under.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight);
    for (var k = 3; k <= 5; k++) {
      var total = n + k;
      var w = (width - (total - 1) * gap) / total;
      if (w < 64) break;
      if (k * w + (k - 1) * gap >= 250) {
        under.style.gridTemplateColumns = 'repeat(' + total + ', minmax(0, 1fr))';
        under.classList.add('is-one-row');
        card.style.gridColumn = 'span ' + k;
        return;
      }
    }
    card.style.gridColumn = '1 / -1';
  };
  Gallery.prototype.setView = function (view) {
    this.view = view;
    var id = this.picker && this.picker.current ? String(this.picker.current.id) : null;
    this.scope.querySelectorAll('[data-gallery-view] [data-view]').forEach(function (el) {
      var v = el.getAttribute('data-view');
      el.hidden = v !== view || (v !== 'sizes' && el.getAttribute('data-variant-media') !== id);
    });
    this.scope.querySelectorAll('[data-thumb-view]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-thumb-view') === view ? 'true' : 'false');
    });
    this.scope.querySelectorAll('.thumbs [data-variant-media]').forEach(function (el) {
      el.hidden = el.getAttribute('data-variant-media') !== id;
    });
  };
  Gallery.prototype.showMedia = function (mediaId) {
    var found = false;
    this.scope.querySelectorAll('[data-gallery-view] [data-media-id]').forEach(function (el) {
      var on = el.getAttribute('data-media-id') === String(mediaId);
      el.hidden = !on; if (on) found = true;
    });
    if (!found) return;
    this.scope.querySelectorAll('[data-thumb-media]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-thumb-media') === String(mediaId) ? 'true' : 'false');
    });
  };
  Gallery.prototype.showVariant = function (v) {
    if (this.mode === 'views') {
      // Picking a size while the sizes are shown together goes back to that one size.
      this.setView(this.view === 'sizes' ? 'boxed' : this.view);
    } else if (v.media) {
      this.showMedia(v.media);
    }
  };

  /* ---------- Homepage step tabs ---------- */
  function Routine(root) {
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-step-tab]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-step-panel]'));
    this.rail = root.querySelector('.steps');
    var self = this;
    this.tabs.forEach(function (t) {
      t.addEventListener('click', function () { self.show(t.getAttribute('data-step-tab')); });
    });
    root.querySelectorAll('[data-go-step]').forEach(function (b) {
      b.addEventListener('click', function () { self.show(b.getAttribute('data-go-step'), true); });
    });
    // Compare handles as plain text, so an odd ?step= value can never break the page.
    var asked = new URLSearchParams(window.location.search).get('step');
    var known = asked && this.panels.some(function (p) { return p.getAttribute('data-step-panel') === asked; });
    if (known) this.show(asked);
    else { this.keepInView(); this.wakeExpress(this.panels.find(function (p) { return !p.hidden; })); }
    this.evenHeights();
  }
  // Tablet and desktop: every step is as tall as the tallest one, so the picture keeps its size and the page
  // below doesn't move as you switch steps. Measured once, and again when the width changes.
  Routine.prototype.evenHeights = function () {
    var self = this;
    var wide = window.matchMedia('(min-width: 750px)');
    var lastWidth = 0;
    function measure() {
      if (window.innerWidth === lastWidth) return;
      lastWidth = window.innerWidth;
      var tallest = 0;
      self.panels.forEach(function (p) { p.style.minHeight = ''; });
      if (!wide.matches) return;
      self.panels.forEach(function (p) {
        var wasHidden = p.hidden;
        // Shown for a moment in place (same width), measured and hidden again before the screen redraws.
        if (wasHidden) { p.hidden = false; p.style.visibility = 'hidden'; }
        tallest = Math.max(tallest, p.offsetHeight);
        if (wasHidden) { p.hidden = true; p.style.visibility = ''; }
      });
      if (tallest) self.panels.forEach(function (p) { p.style.minHeight = tallest + 'px'; });
    }
    function again() { lastWidth = 0; measure(); }
    measure();
    window.addEventListener('resize', measure);
    window.addEventListener('load', again);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(again);
  };
  Routine.prototype.show = function (handle, moveFocus) {
    var self = this;
    this.tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-step-tab') === handle ? 'true' : 'false'); });
    this.panels.forEach(function (p) {
      p.hidden = p.getAttribute('data-step-panel') !== handle;
      if (!p.hidden) self.wakeExpress(p);
    });
    this.keepInView();
    if (moveFocus) {
      // "Next step": bring the step rail into view and put focus on the new step's tab.
      var tab = this.tabs.find(function (t) { return t.getAttribute('data-step-tab') === handle; });
      if (this.rail && this.rail.getBoundingClientRect().top < 0) this.rail.scrollIntoView({ block: 'start' });
      if (tab) tab.focus({ preventScroll: true });
    }
  };
  // Shop Pay is only built for a step when it is opened, so the homepage loads one button, not six.
  Routine.prototype.wakeExpress = function (panel) {
    if (!panel) return;
    var tpl = panel.querySelector('template[data-express-template]');
    if (!tpl) return;
    var slot = tpl.parentNode;
    slot.appendChild(tpl.content.cloneNode(true));
    tpl.remove();
  };
  // Keep the chosen step visible inside the scrolling rail, without moving the page.
  Routine.prototype.keepInView = function () {
    var rail = this.rail;
    if (!rail || rail.scrollWidth <= rail.clientWidth) return;
    var on = rail.querySelector('[aria-pressed="true"]');
    if (!on) return;
    var left = on.offsetLeft - rail.offsetLeft;
    var right = left + on.offsetWidth - 16;
    if (left - 20 < rail.scrollLeft || right > rail.scrollLeft + rail.clientWidth) {
      rail.scrollTo({ left: Math.max(0, left - 20), behavior: 'smooth' });
    }
  };

  /* ---------- Delivery window ---------- */
  function deliveryWindow() {
    document.querySelectorAll('[data-delivery]').forEach(function (el) {
      var min = Number(el.getAttribute('data-min')) || 4;
      var max = Math.max(min, Number(el.getAttribute('data-max')) || 11);
      var day = 24 * 60 * 60 * 1000, now = Date.now();
      var fmt;
      try { fmt = new Intl.DateTimeFormat(T.locale, { month: 'long', day: 'numeric' }); }
      catch (e) { fmt = new Intl.DateTimeFormat(undefined, { month: 'long', day: 'numeric' }); }
      el.textContent = (T.strings.delivery || '').replace('{from}', fmt.format(new Date(now + min * day))).replace('{to}', fmt.format(new Date(now + max * day))).replace('{pack}', el.getAttribute('data-pack') || '');
    });
  }

  /* ---------- Phone menu: keeps focus inside, locks the page behind it, closes on Escape ---------- */
  function phoneMenu() {
    document.querySelectorAll('[data-menu]').forEach(function (d) {
      if (bound(d, 'Menu')) return;
      var summary = d.querySelector('summary');
      function setInert(on) {
        document.querySelectorAll('#main, .shopify-section-group-footer-group, [data-bag-bar], .announcement, .site-header__logo, .site-header__side--end').forEach(function (el) {
          if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
        });
      }
      d.addEventListener('toggle', function () {
        document.documentElement.classList.toggle('menu-open', d.open);
        setInert(d.open);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && d.open) { d.open = false; summary.focus(); }
      });
      d.querySelectorAll('.menu-panel a').forEach(function (a) {
        a.addEventListener('click', function () { d.open = false; });
      });
      window.matchMedia('(min-width: 901px)').addEventListener('change', function (m) { if (m.matches) d.open = false; });
    });
  }

  /* ---------- Country and currency picker ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-localization] select');
    if (sel) sel.form.submit();
  });

  /* ---------- Collection: step filter, stock and sort, in the page ---------- */
  function countText(el, n) {
    return (n === 1 ? el.getAttribute('data-one') : el.getAttribute('data-other')).replace('{count}', n);
  }
  function sortCards(cards, sort) {
    var num = function (c, k) { return Number(c.getAttribute(k)) || 0; };
    return cards.slice().sort(function (a, b) {
      if (sort === 'low') return num(a, 'data-price') - num(b, 'data-price') || num(a, 'data-order') - num(b, 'data-order');
      if (sort === 'high') return num(b, 'data-price') - num(a, 'data-price') || num(a, 'data-order') - num(b, 'data-order');
      if (sort === 'az') return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
      if (sort === 'relevance') return num(a, 'data-position') - num(b, 'data-position');
      return num(a, 'data-order') - num(b, 'data-order') || num(a, 'data-position') - num(b, 'data-position');
    });
  }
  function Collection(root) {
    var toolbar = root.querySelector('[data-toolbar]');
    var grid = root.querySelector('[data-grid]');
    if (!toolbar || !grid) return;
    toolbar.hidden = false;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-card]'));
    var countEl = root.querySelector('[data-count]');
    var empty = root.querySelector('[data-empty]');
    var stock = toolbar.querySelector('[data-stock-only]');
    var sortSel = toolbar.querySelector('[data-sort]');
    var filters = Array.prototype.slice.call(toolbar.querySelectorAll('[data-filter]'));
    var params = new URLSearchParams(location.search);
    var group = params.get('group') || params.get('step') || 'all';
    if (!filters.some(function (b) { return b.getAttribute('data-filter') === group; })) group = 'all';
    stock.checked = params.get('stock') === '1';
    var askedSort = params.get('sort');
    if (askedSort && Array.prototype.some.call(sortSel.options, function (o) { return o.value === askedSort; })) sortSel.value = askedSort;
    if (!sortSel.value) sortSel.value = 'routine';
    var radios = Array.prototype.slice.call(toolbar.querySelectorAll('[data-sort-radio]'));
    var done = toolbar.querySelector('[data-filter-done]');
    var badge = toolbar.querySelector('[data-filter-count]');

    function apply(push) {
      filters.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-filter') === group)); });
      var shown = 0;
      sortCards(cards, sortSel.value).forEach(function (c) {
        var ok = (group === 'all' || c.getAttribute('data-group') === group) && (!stock.checked || c.getAttribute('data-available') === 'true');
        c.hidden = !ok;
        if (ok) shown++;
        grid.appendChild(c);
      });
      countEl.textContent = countText(countEl, shown);
      empty.hidden = shown > 0;
      grid.hidden = shown === 0;
      radios.forEach(function (r) { r.checked = r.value === sortSel.value; });
      if (done) done.textContent = countText(done, shown);
      if (badge) {
        var active = (group !== 'all' ? 1 : 0) + (stock.checked ? 1 : 0) + (sortSel.value !== 'routine' ? 1 : 0);
        badge.textContent = active;
        badge.hidden = active === 0;
      }
      if (push) {
        var p = new URLSearchParams(location.search);
        p.delete('step');
        group === 'all' ? p.delete('group') : p.set('group', group);
        stock.checked ? p.set('stock', '1') : p.delete('stock');
        sortSel.value === 'routine' ? p.delete('sort') : p.set('sort', sortSel.value);
        var q = p.toString();
        history.replaceState(null, '', location.pathname + (q ? '?' + q : ''));
      }
    }
    filters.forEach(function (b) {
      b.addEventListener('click', function () { group = b.getAttribute('data-filter'); apply(true); });
    });
    stock.addEventListener('change', function () { apply(true); });
    sortSel.addEventListener('change', function () { apply(true); });
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { sortSel.value = r.value; apply(true); } });
    });
    var clear = toolbar.querySelector('[data-filter-clear]');
    if (clear) clear.addEventListener('click', function () { group = 'all'; stock.checked = false; sortSel.value = 'routine'; apply(true); });
    root.querySelector('[data-show-sold-out]').addEventListener('click', function () { stock.checked = false; apply(true); });
    apply(false);
    FilterSheet(toolbar);
  }

  /* Phones: the filter controls open in a sheet from the bottom. They move into a <dialog> while open
     (focus stays inside, Escape closes, the page behind can't be reached) and move back when it closes. */
  function FilterSheet(toolbar, owner) {
    var open = toolbar.querySelector('[data-filter-open]');
    var sheet = toolbar.querySelector('[data-filter-sheet]');
    if (!open || !sheet || typeof HTMLDialogElement === 'undefined') return;
    owner = owner || toolbar;
    if (owner.filterDialog) { if (owner.filterDialog.open) owner.filterDialog.close(); owner.filterDialog.remove(); }
    var dialog = document.createElement('dialog');
    owner.filterDialog = dialog;
    dialog.className = 'filter-dialog';
    dialog.setAttribute('aria-labelledby', sheet.getAttribute('aria-labelledby'));
    document.body.appendChild(dialog);
    var home = document.createComment('filter-sheet');
    sheet.parentNode.insertBefore(home, sheet);
    function close() { if (dialog.open) dialog.close(); }
    open.addEventListener('click', function () {
      dialog.appendChild(sheet);
      dialog.showModal();
      open.setAttribute('aria-expanded', 'true');
      var first = sheet.querySelector('.opt[aria-pressed="true"]') || sheet.querySelector('button');
      if (first) first.focus();
    });
    dialog.addEventListener('close', function () {
      if (!home.parentNode) return; // the results were replaced while it was open
      home.parentNode.insertBefore(sheet, home.nextSibling);
      open.setAttribute('aria-expanded', 'false');
      open.focus();
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); }); // tap on the dimmed backdrop
    sheet.querySelectorAll('[data-filter-close], [data-filter-done]').forEach(function (b) { b.addEventListener('click', close); });
    window.matchMedia('(min-width: 750px)').addEventListener('change', function (m) { if (m.matches && dialog.isConnected) close(); });
  }

  /* ---------- Search: results as you type, then kind, stock and sort in the page ---------- */
  function SearchResults(root) {
    var bar = root.querySelector('[data-search-toolbar]');
    if (!bar) return null;
    var kinds = bar.querySelector('[data-kinds]');
    var controls = bar.querySelector('[data-search-controls]');
    var grid = root.querySelector('[data-grid]');
    var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-card]')) : [];
    var articleBlock = root.querySelector('[data-block="articles"]');
    var productBlock = root.querySelector('[data-block="products"]');
    var articles = articleBlock ? articleBlock.querySelectorAll('li').length : 0;
    var stock = controls && controls.querySelector('[data-stock-only]');
    var sortSel = controls && controls.querySelector('[data-sort]');
    var countEl = bar.querySelector('[data-search-count]');
    var radios = Array.prototype.slice.call(bar.querySelectorAll('[data-sort-radio]'));
    var done = bar.querySelector('[data-filter-done]');
    var badge = bar.querySelector('[data-filter-count]');
    var kind = 'all';
    kinds.hidden = false;
    if (controls) controls.hidden = false;
    function pill(key, n) { return bar.getAttribute('data-pill-' + key).replace('%count%', n); }
    function apply() {
      var shown = 0;
      if (grid) {
        sortCards(cards, sortSel.value).forEach(function (c) {
          var ok = !stock.checked || c.getAttribute('data-available') === 'true';
          c.hidden = !ok;
          if (ok) shown++;
          grid.appendChild(c);
        });
      }
      var total = shown + articles;
      kinds.querySelectorAll('[data-kind]').forEach(function (b) {
        var k = b.getAttribute('data-kind');
        b.setAttribute('aria-pressed', String(k === kind));
        b.textContent = pill(k, k === 'all' ? total : k === 'products' ? shown : articles);
      });
      countEl.textContent = (total === 1 ? bar.getAttribute('data-one') : bar.getAttribute('data-other')).replace('%count%', total).replace('%q%', bar.getAttribute('data-q'));
      if (productBlock) productBlock.hidden = kind === 'articles' || shown === 0;
      if (articleBlock) articleBlock.hidden = kind === 'products';
      var visible = kind === 'all' ? total : kind === 'products' ? shown : articles;
      if (done) done.textContent = countText(done, visible);
      radios.forEach(function (r) { r.checked = sortSel && r.value === sortSel.value; });
      if (badge) {
        var active = (kind !== 'all' ? 1 : 0) + (stock && stock.checked ? 1 : 0) + (sortSel && sortSel.value !== 'relevance' ? 1 : 0);
        badge.textContent = active;
        badge.hidden = active === 0;
      }
    }
    kinds.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kind]');
      if (b) { kind = b.getAttribute('data-kind'); apply(); }
    });
    if (stock) stock.addEventListener('change', apply);
    if (sortSel) sortSel.addEventListener('change', apply);
    radios.forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked && sortSel) { sortSel.value = r.value; apply(); } });
    });
    var clear = bar.querySelector('[data-filter-clear]');
    if (clear) clear.addEventListener('click', function () {
      kind = 'all';
      if (stock) stock.checked = false;
      if (sortSel) sortSel.value = 'relevance';
      apply();
    });
    apply();
    FilterSheet(bar, root);
    return countEl;
  }
  function Search(root) {
    var form = root.querySelector('[data-search-form]');
    var input = root.querySelector('[data-search-input]');
    var clear = root.querySelector('[data-search-clear]');
    var results = root.querySelector('[data-search-results]');
    var id = root.getAttribute('data-section-id');
    var timer = null, ctl = null, last = input.value.trim(), seq = 0;
    function run() {
      var q = input.value.trim();
      if (q === last) return;
      last = q;
      clear.hidden = q === '';
      if (ctl) ctl.abort();
      ctl = window.AbortController ? new AbortController() : null;
      var mine = ++seq;
      var params = new URLSearchParams(new FormData(form));
      results.setAttribute('aria-busy', 'true');
      fetch(form.action + '?' + params.toString() + '&section_id=' + encodeURIComponent(id), { signal: ctl ? ctl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('search'); return r.text(); })
        .then(function (html) {
          if (mine !== seq) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-search-results]');
          if (!fresh) { results.setAttribute('aria-busy', 'false'); return; }
          results.innerHTML = fresh.innerHTML;
          results.setAttribute('aria-busy', 'false');
          var countEl = SearchResults(root);
          document.querySelectorAll('[data-bag-control]').forEach(syncStepper);
          // The swapped-in text is not reliably read out, so announce the result in the page's status region.
          var said = countEl ? countEl.textContent : (results.querySelector('.search-empty__title') || {}).textContent;
          if (said) announce(said);
          var url = q ? form.action + '?' + params.toString() : form.action;
          history.replaceState(null, '', url);
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') results.setAttribute('aria-busy', 'false'); });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 280); });
    form.addEventListener('submit', function (e) { e.preventDefault(); clearTimeout(timer); last = null; run(); });
    clear.addEventListener('click', function (e) { e.preventDefault(); input.value = ''; input.focus(); run(); });
    SearchResults(root);
  }

  /* ---------- Cart page: change, remove and add without leaving the page ---------- */
  function Cart(root) {
    var id = root.getAttribute('data-section-id');
    var busy = false;
    function refresh(focusSel) {
      return fetch(location.pathname + '?section_id=' + encodeURIComponent(id))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart]');
          if (!fresh) return;
          root.innerHTML = fresh.innerHTML;
          var target = focusSel && root.querySelector(focusSel);
          if (!target) target = root.querySelector('.page__title');
          if (target) {
            if (!target.hasAttribute('tabindex') && !/^(A|BUTTON|INPUT|TEXTAREA)$/.test(target.tagName)) target.setAttribute('tabindex', '-1');
            target.focus({ preventScroll: true });
          }
        });
    }
    function done(cart, focusSel) {
      rememberCart(cart);
      return refresh(focusSel).then(function () { announce(T.strings.cartUpdated || ''); });
    }
    function fail(err) { notice((err && err.message) || T.strings.cartError); busy = false; return refresh(); }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-line-change]');
      if (!a) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      var key = a.getAttribute('data-key');
      var q = Number(a.getAttribute('data-quantity'));
      var line = a.closest('.line');
      var idx = Array.prototype.indexOf.call(root.querySelectorAll('.line'), line);
      var isPlus = q > 0 && a === line.querySelector('.line__qty a:last-child');
      var focusSel = q === 0 ? '.line:nth-child(' + Math.max(1, idx) + ') .line__remove'
        : '.line:nth-child(' + (idx + 1) + ') .line__qty ' + (isPlus ? 'a:last-child' : '.qty-btn:first-child');
      root.querySelectorAll('.line').forEach(function (l) { l.setAttribute('aria-busy', 'true'); });
      fetch(T.cartChangeUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: q })
      }).then(function (r) { if (!r.ok) return cartError(r); return r.json(); })
        .then(function (cart) { return done(cart, focusSel); })
        .then(function () { busy = false; })
        .catch(fail);
    });
    // The quantity and Remove controls are links that act as buttons, so Space works on them too.
    root.addEventListener('keydown', function (e) {
      var a = e.target.closest('[data-line-change]');
      if (a && (e.key === ' ' || e.key === 'Spacebar')) { e.preventDefault(); a.click(); }
    });
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cart-add]');
      if (!form) return;
      e.preventDefault();
      if (busy) return;
      busy = true;
      fetch(T.cartAddUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }] })
      }).then(function (r) { if (!r.ok) return cartError(r); return fetch(T.cartUrl, { headers: { 'Accept': 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) { return done(cart, '.cart-routine .band__title'); })
        .then(function () { busy = false; })
        .catch(fail);
    });
    // The order note saves as the shopper types, and also goes with the Check Out form.
    var noteTimer = null;
    root.addEventListener('input', function (e) {
      var note = e.target.closest('[data-cart-note]');
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch(T.cartUpdateUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: note.value })
        }).catch(function () {});
      }, 500);
    });
    // A stepper elsewhere on the page changed the bag.
    document.addEventListener('bag:changed', function () { if (!busy) refresh(); });
  }

  /* ---------- "Goes well with": Search & Discovery complementary products ---------- */
  function Recommendations(root) {
    var url = root.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (!fresh || !fresh.querySelector('.prow')) return;
      root.innerHTML = fresh.innerHTML;
      root.hidden = false;
      document.querySelectorAll('[data-bag-control]').forEach(syncStepper);
    }).catch(function () {});
  }

  /* ---------- Product page and article guide: sticky columns that never hide their own bottom ---------- */
  function stickyColumns() {
    var cols = document.querySelectorAll('.product > .gallery, .product > .buy, .post-page__body > .guide');
    if (!cols.length) return;
    function fit() {
      cols.forEach(function (c) {
        var room = window.innerHeight - c.offsetHeight - 24;
        c.style.setProperty('--sticky-top', Math.min(24, room) + 'px');
      });
    }
    fit();
    window.addEventListener('resize', fit);
    if (window.ResizeObserver) { var ro = new ResizeObserver(fit); cols.forEach(function (c) { ro.observe(c); }); }
  }

  /* ---------- Product page: line the columns up once, so opening a panel doesn't move the right side ---------- */
  function balanceColumns() {
    var buy = document.querySelector('.product > .buy');
    var gallery = document.querySelector('.product > .gallery');
    if (!buy || !gallery || !window.matchMedia) return;
    var wide = window.matchMedia('(min-width: 901px)');
    var lastWidth = 0;
    function fit(force) {
      if (!force && window.innerWidth === lastWidth) return; // ignore height-only resizes (phone toolbars)
      lastWidth = window.innerWidth;
      buy.style.minHeight = '';
      if (wide.matches) buy.style.minHeight = gallery.offsetHeight + 'px';
    }
    fit(true);
    window.addEventListener('resize', function () { fit(false); });
    window.addEventListener('load', function () { fit(true); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(true); });
  }

  function init() {
    phoneMenu();
    document.querySelectorAll('[data-cart]').forEach(function (r) { if (!bound(r, 'Cart')) Cart(r); });
    document.querySelectorAll('[data-search]').forEach(function (r) { if (!bound(r, 'Search')) Search(r); });
    document.querySelectorAll('[data-collection]').forEach(function (r) { if (!bound(r, 'Collection')) Collection(r); });
    document.querySelectorAll('[data-recommendations][data-url]').forEach(function (r) { if (!bound(r, 'Recs')) Recommendations(r); });
    document.querySelectorAll('[data-routine]').forEach(function (r) {
      if (bound(r, 'Routine')) return;
      try { new Routine(r); } catch (e) { /* never let the tabs stop the rest of the page */ }
    });
    document.querySelectorAll('[data-picker]').forEach(function (root) {
      if (bound(root, 'Picker')) return;
      var p = new Picker(root);
      var page = root.closest('[data-product-page]');
      if (page) {
        var g = new Gallery(page, p);
        p.scope.gallery = g;
        if (g.mode === 'views') g.setView('boxed');
      }
    });
    deliveryWindow();
    if (!document.documentElement.hasAttribute('data-sticky-bound')) { document.documentElement.setAttribute('data-sticky-bound', ''); stickyColumns(); balanceColumns(); }
    if (document.querySelector('[data-bag-control], [data-search]')) fetchCart().catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
